
// Importing Libraries
import axios from "axios";

// --- Constants ----------------------------------------------------------------------------------
// const API_HOST = "http://localhost:4000";
// const API_HOST = "https://masroor-academy-vic.herokuapp.com";
const API_HOST = "https://masrooracademyvic.com.au";
const USER_KEY = "user";
const SELECT_KEY = "SelectedID";
const SELECT_KEY2 = "SelectedID2";

// --- CSRF Token -------------------------------------------------------------------------------
async function fetchCSRF(){
  const csrfResponse = await axios.get(API_HOST + "/MAApi/csrf-token", { withCredentials: true });
  const csrfToken = csrfResponse.data.csrfToken; // Extract token
  return csrfToken;
}

// --- User ---------------------------------------------------------------------------------------
// Verify User Request For API from DB
async function verifyUser(id, password) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/users/Sign-in", { id, password }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });
  return response;
}

async function signOutUser() {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/users/logout", {}, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });
  return response;
}

async function checkAuth(){
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/users/checkAuth", {}, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });
  return response;
}

// Get User Details Request For API from DB
async function getProfile(id) {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/users/get/${id}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Function to send password reset email
// Send Email Request For API from
async function sendPasswordResetEmail(id, studentName) {
  const csrfToken = await fetchCSRF();
  // Using Axios to call an API endpoint
  const response = await axios.post(API_HOST + `/MAApi/password-reset/${id}/${studentName}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function resetPassword(token, newPassword) {
  const csrfToken = await fetchCSRF();
  // Using Axios to call an API endpoint
  const response = await axios.post(API_HOST + "/MAApi/password-reset/newPassword", { token, newPassword }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function sendRegistrationEmail(userDetails) {
  const csrfToken = await fetchCSRF();
  // Using Axios to call an API endpoint
  const response = await axios.post(API_HOST + `/MAApi/users/sendEmail`, userDetails, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}


// Get User Details Request For API from DB
async function getProfileRegister(id) {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/users/getRegister/${id}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Get User Details Request For API from DB
async function getProfileUsers() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/users`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Get User Details Request For API from DB
async function checkUserExists(name, fathersName) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + `/MAApi/users/check`, { name, fathersName }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Create User Request For API to DB
async function createUser(user) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/users", user, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Create User Request For API to DB
async function createUserAdmin(user) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/users/create", user, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Update User Details Request For API to DB
async function updateUser(user, id, loggedInUser) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + `/MAApi/users/update/${id}`, user, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  const updatedUser = response.data;

  if (loggedInUser === id)
    setUser(updatedUser);

  return updatedUser;

}

// Delete User Request For API from DB
async function deleteUserDB(user) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/users/delete", user, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// --- Homework Posts ---------------------------------------------------------------------------------------
// Get Homeworks Details Request For API from DB
async function getHomeworks() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/homeworks", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getHomeworksByID(classname, studentID) {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/homeworks/get/${classname}/${studentID}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Create Homework Request For API from DB
async function createHomeworks(homework) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/homeworks/create", homework, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function editHomeworks(classname, studentID, homework) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + `/MAApi/homeworks/update/${classname}/${studentID}`, { homework }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Delete Homework Request For API from DB
async function deleteHomeworks(homeworkID) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/homeworks/delete", homeworkID, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Delete All Homework associated with User Request For API from DB
async function deleteHomeworks2(id) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/homeworks/delete2", id, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Delete specific Homework Request For API from DB
async function deleteHomeworksByID(classname, studentID, unused) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + `/MAApi/homeworks/delete3/${classname}/${studentID}`, unused, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// --- Announcements ---------------------------------------------------------------------------------------
// Create Announcements Request For API from DB
async function createAnnouncements(announcement) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/announcements/create", announcement, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Get Announcements Request For API from DB
async function getAnnouncements() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/announcements", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Delete Announcements Request For API from DB
async function deleteAnnouncements(announcement) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/announcements/delete", announcement, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Send Announcements Email Request For API from DB
async function sendAnnouncementEmail(announcement) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/announcements/notify", announcement, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// --- Form Status ---------------------------------------------------------------------------------------

// Get Form Status Request For API from DB
async function getFormStatus() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/formStatus", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Update Form Status Request For API from DB
async function updateFormStatus(formStatus) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/formStatus/updateFormStatus", formStatus, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Update Form Text Request For API from DB
async function updateFormText(formText) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/formStatus/updateFormText", formText, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Update Registration Message Request For API from DB
async function updateRegFormMessage(formText) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/formStatus/updateRegFormMessage", formText, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Get Registration Message Request For API from DB
async function getRegFormMessage() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/formStatus/getRegFormMessage", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// ---------- Resources --------------------------------------------
// Sets Current User In Local Storage
async function uploadResource(formData) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/resources/upload", formData, {
    withCredentials: true,
    headers: {
      "X-CSRF-Token": csrfToken,
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
}

async function fetchResources() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/resources", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });
  return response.data;
}


async function fetchResourcesByID(resourcesID) {
  const response = API_HOST + `/MAApi/resources/${resourcesID}`;
  return response;
}

// Delete resources Request For API from DB
async function deleteResources(resource) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/resources/delete", resource, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// ---------- Images --------------------------------------------

async function fetchImages() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/image", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });
  return response.data;
}

// ---------- Groups and Classes --------------------------------------------

async function createGroup(group) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/groups", group, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getGroups() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/groups", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });
  return response.data;
}

// Get User Details Request For API from DB
async function getGroupById(id) {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/groups/get/${id}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Update Group Details Request For API to DB
async function editGroup(group, id,) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + `/MAApi/groups/update/${id}`, group, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;

}

// Delete User Request For API from DB
async function deleteGroup(group) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/groups/delete", group, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function createClass(classes) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/classes", classes, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getClasses() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/classes", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });
  return response.data;
}

async function getClassById(id) {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/classes/get/${id}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Update Classes Details Request For API to DB
async function editClass(classes, id,) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + `/MAApi/classes/update/${id}`, classes, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;

}

// Delete Classes Request For API from DB
async function deleteClass(classes) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/classes/delete", classes, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// ---------- Syllabus --------------------------------------------

async function createSyllabus(groupId, syllabus) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/syllabus", { groupId, syllabus }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getSyllabus() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/syllabus", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });
  return response.data;
}

async function getSyllabusById(id) {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/syllabus/get/${id}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Delete User Request For API from DB
async function deleteSyllabus(syllabus) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/syllabus/delete", syllabus, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Update Registration Message Request For API from DB
async function updateSyllabus(groupId, syllabus) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/syllabus/update", { groupId, syllabus }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// ---------- Attendance --------------------------------------------
async function createAttendance(date, markedAttendance) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/attendance", { date, markedAttendance }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getAttendance(date) {
  const csrfToken = await fetchCSRF();
  const encodedDate = encodeURIComponent(date);
  const response = await axios.get(API_HOST + `/MAApi/attendance/${encodedDate}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getAllAttendance() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/attendance", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function updateAttendance(date, markedAttendance) {
  const csrfToken = await fetchCSRF();
  const encodedDate = encodeURIComponent(date);
  const response = await axios.post(API_HOST + `/MAApi/attendance/update/${encodedDate}`, { markedAttendance }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function deleteAttendance(attendance) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/attendance/delete", attendance, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}


// ---------- Homework --------------------------------------------
async function createHomework(homework) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/homework", homework, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getHomework() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/homework", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });
  return response.data;
}

async function getHomeworkById(id) {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/homework/get/${id}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// Update Classes Details Request For API to DB
async function editHomework(homework, id) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + `/MAApi/homework/update/${id}`, homework, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;

}

// Delete Classes Request For API from DB
async function deleteHomework(homework) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/homework/delete", homework, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

// ---------- Results --------------------------------------------
async function createResults(classname, markedHomeworks, studentID, studentGroup, studentResult) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/results", { classname, markedHomeworks, studentID, studentGroup, studentResult }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getResults(classname, studentID) {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/results/get/${classname}/${studentID}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getResultsByID(id) {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/results/get/${id}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getAllResults() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/results", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function updateResults(classname, markedHomeworks, studentID, studentGroup, studentResult) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + `/MAApi/results/update/${classname}/${studentID}`, { markedHomeworks, studentGroup, studentResult }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function deleteResults(result) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/results/delete", result, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}


// ---------- Fianl Results --------------------------------------------
async function createFinalResults(studentID, studentName, studentGroup, studentGender, fathersName, mothersName, parentEmail, studentEmail, attendanceResult) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/finalResults", { studentID, studentName, studentGroup, studentGender, fathersName, mothersName, parentEmail, studentEmail, attendanceResult }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getFinalResultsByID(studentID) {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + `/MAApi/finalResults/get/${studentID}`, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function getAllFinalResults() {
  const csrfToken = await fetchCSRF();
  const response = await axios.get(API_HOST + "/MAApi/finalResults", { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function updateFinalResults(studentID, attendanceResult) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + `/MAApi/finalResults/update/${studentID}`, { attendanceResult }, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}

async function deleteFinalResults(result) {
  const csrfToken = await fetchCSRF();
  const response = await axios.post(API_HOST + "/MAApi/finalResults/delete", result, { withCredentials: true, headers: { "X-CSRF-Token": csrfToken }, });

  return response.data;
}


// --- Helper functions to interact with local storage --------------------------------------------
// Sets Current User In Local Storage
function setUser(user) {
  sessionStorage.setItem(USER_KEY, JSON.stringify(user));
}

// Get User Details from Local Storage
function getUser() {
  return JSON.parse(sessionStorage.getItem(USER_KEY));
}

// Removes user from Local Storage
function removeUser() {
  sessionStorage.removeItem(USER_KEY);
}

function selectedId(id) {
  sessionStorage.setItem(SELECT_KEY, JSON.stringify(id));
}

function selectedId2(name) {
  sessionStorage.setItem(SELECT_KEY2, JSON.stringify(name));
}

function loggedInUser(name) {
  sessionStorage.setItem("LoggedIn", JSON.stringify(name));
}

function getloggedInUser() {
  return JSON.parse(sessionStorage.getItem("LoggedIn"));
}

// Removes user from Local Storage
function removeLoggedInUser() {
  sessionStorage.removeItem("LoggedIn");
}

function getSelectedId() {
  return JSON.parse(sessionStorage.getItem(SELECT_KEY));
}

function getSelectedId2() {
  return JSON.parse(sessionStorage.getItem(SELECT_KEY2));
}

function removeSelectedId() {
  sessionStorage.removeItem(SELECT_KEY);
}

function removeSelectedId2() {
  sessionStorage.removeItem(SELECT_KEY2);
}


// Exports all these functions to be used by other componenets
export {
  verifyUser, createUser, checkUserExists, createUserAdmin,
  getHomeworks, createHomeworks, deleteHomeworks, editHomeworks,
  getUser, removeUser, deleteUserDB, fetchCSRF,
  getProfile, updateUser, setUser, deleteHomeworks2, getHomeworksByID, deleteHomeworksByID,
  createAnnouncements, getAnnouncements, getProfileRegister,
  getProfileUsers, deleteAnnouncements, selectedId, getSelectedId,
  getloggedInUser, loggedInUser, removeLoggedInUser, removeSelectedId,
  getSelectedId2, removeSelectedId2, selectedId2, updateFormStatus, getFormStatus, updateFormText,
  uploadResource, fetchResources, deleteResources, fetchResourcesByID, fetchImages,
  updateRegFormMessage, getRegFormMessage, createClass, createGroup, getClasses, getGroups,
  getGroupById, getClassById, deleteGroup, deleteClass, createSyllabus, getSyllabus,
  getSyllabusById, deleteSyllabus, updateSyllabus, editGroup, editClass,
  createAttendance, getAttendance, updateAttendance, deleteAttendance, getAllAttendance,
  createHomework, getHomework, getHomeworkById, editHomework, deleteHomework,
  createResults, updateResults, deleteResults, getAllResults, getResults, getResultsByID,
  createFinalResults, updateFinalResults, deleteFinalResults, getAllFinalResults, getFinalResultsByID,
  sendPasswordResetEmail, resetPassword, sendAnnouncementEmail, sendRegistrationEmail, checkAuth, signOutUser
}
